import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const NOTIFICATIONS = [
  {
    id: 1,
    type: 'critical',
    icon: 'dollar',
    title: 'Low Funding Alert',
    message: 'Rocky Mountain - TO2 (CNT-2024-005B) is at 92% burn with only $48K remaining in funded ceiling.',
    time: '25 min ago',
  },
  {
    id: 2,
    type: 'warning',
    icon: 'user',
    title: 'Staffing Required',
    message: 'Glacier (CNT-2023-006A) has 2 unfilled positions that must be onboarded before OY3 start date.',
    time: '1 hr ago',
  },
  {
    id: 3,
    type: 'info',
    icon: 'edit',
    title: 'Data Entry Error',
    message: 'Keanu Reeves entered incorrect contract value for Crater Lake - Nightwing (CNT-2024-026). Review required.',
    time: '3 hrs ago',
  },
];

function NotificationIcon({ type }) {
  if (type === 'dollar') {
    return (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    );
  }
  if (type === 'user') {
    return (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <line x1="23" y1="11" x2="17" y2="11" />
      </svg>
    );
  }
  // edit / pencil
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  );
}

function Header({ title }) {
  const [showNotifications, setShowNotifications] = useState(false);
  const panelRef = useRef(null);
  const btnRef = useRef(null);

  // Close panel when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (
        showNotifications &&
        panelRef.current && !panelRef.current.contains(e.target) &&
        btnRef.current && !btnRef.current.contains(e.target)
      ) {
        setShowNotifications(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showNotifications]);

  return (
    <header className="top-header">
      <div className="header-left">
        <h2>{title}</h2>
      </div>
      <div className="header-right">
        <div className="header-search">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input type="text" placeholder="Search..." />
        </div>
        <div className="notification-wrapper">
          <button
            className="icon-btn"
            ref={btnRef}
            onClick={() => setShowNotifications((v) => !v)}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
              <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
            <span className="notification-dot"></span>
          </button>

          {showNotifications && (
            <div className="notification-panel" ref={panelRef}>
              <div className="notification-panel-header">
                <span className="notification-panel-title">Alerts</span>
                <span className="notification-panel-count">{NOTIFICATIONS.length}</span>
              </div>
              <div className="notification-panel-list">
                {NOTIFICATIONS.map((n) => (
                  <div key={n.id} className={`notification-item notification-${n.type}`}>
                    <div className={`notification-item-icon ${n.type}`}>
                      <NotificationIcon type={n.icon} />
                    </div>
                    <div className="notification-item-content">
                      <div className="notification-item-title">{n.title}</div>
                      <div className="notification-item-message">{n.message}</div>
                      <div className="notification-item-time">{n.time}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

NotificationIcon.propTypes = {
  type: PropTypes.string.isRequired,
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Header;
